$(document).ready(function () {
  // Prepend General Message Banner to Header
  $('.generalmessage').prependTo('header');

  // Update placeholder behavior for the search input
  $('.searchBoxInput input').on('focus', function() {
      $(this).removeAttr('placeholder');
  }).on('blur', function() {
      $(this).attr('placeholder', 'Search Website');
  });
  
  // Email Signup
  const $emailSignup = $('.emailSignup');
  $emailSignup.find('.emailSubmitButton').text('SUBSCRIBE');
  $emailSignup.find('.inputFieldTextbox').val('');
  $emailSignup.find('.inputFieldTextbox').attr('placeholder', 'Email Address');
  $emailSignup.find('.emailSignupText').html("GET GLASS CITY CENTER UPDATES");

  // Custom Email Signup
  $('.custom-email-signup button').on('click', function(event) {
    event.preventDefault();
        var emailAddress = $('.custom-email-signup input').val();
        $('.emailSignup .inputFieldTextbox').val(emailAddress);
        $('.emailSignup .emailSubmitButton').click();
    });
});

$(window).load(function () {


});